import { render, staticRenderFns } from "./WorkshopsPayments.vue?vue&type=template&id=2f6d6072&scoped=true&"
import script from "./WorkshopsPayments.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d6072",
  null
  
)

export default component.exports